import React from "react";
import ResponsiveTable from "./ResponsiveTable";
import { FaUser } from "react-icons/fa";

const FamilyView = ({ currentRecord }) => {
  return (
    <div className="overflow-hidden bg-white rounded-lg shadow-md">
      <div className="flex items-center p-4 bg-blue-500">
        {currentRecord?.image ? (
          <img
            crossOrigin="anonymous"
            src={`${process.env.REACT_APP_REPORTS_DOWNLOAD_URL}uploads/family/${currentRecord?.image}`}
            alt="Family Image"
            className="object-cover w-20 h-20 mr-4 border-2 border-white rounded-full"
          />
        ) : (
          <div className="flex items-center justify-center w-20 h-20 mr-4 bg-white rounded-full">
            <FaUser className="text-3xl text-blue-500" />
          </div>
        )}
        <div className="text-white">
          <h2 className="text-2xl font-bold">{currentRecord?.family_name}</h2>
          <p className="text-sm opacity-80">{currentRecord?.family_code}</p>
        </div>
      </div>
      <div className="p-4">
        <ResponsiveTable json={currentRecord} />
      </div>
    </div>
  );
};

export default FamilyView;
